<!-- <template>
  <div class="page-badges-teachaer-wrap"></div>
</template> -->
<script>
/**
 * @module BadgesTeachaer
 * @desc 成就系统 徽章 教师端
 */
import StudentBadges from '../index.vue';
import Login from '@/utils/login';
export default {
  name: 'BadgesTeachaer',
  extends: StudentBadges,
  async created() {
    const isLogin = await Login.isLogin(Login.ROLES.TEACHER);
    if (!isLogin) {
      Login.redirectToLogin();
    }
  }
};
</script>
